import './pageFiles';
import { getPageContext } from './getPageContext';
import { assertRenderHook } from './assertRenderHook';
import { assertHook } from '../shared/getHook';
import { assertIsBundledOnce } from './utils';
if (import.meta.env.PROD)
    assertIsBundledOnce();
hydrate();
async function hydrate() {
    var _a, _b;
    const pageContext = await getPageContext();
    assertRenderHook(pageContext);
    await pageContext.exports.render(pageContext);
    assertHook(pageContext, 'onHydrationEnd');
    await ((_b = (_a = pageContext.exports).onHydrationEnd) === null || _b === void 0 ? void 0 : _b.call(_a, pageContext));
}
